import React, { ChangeEvent, FC, useState } from 'react';
import { ContentWrapperWidget, MainTemplate } from '../../components/layouts';
import { useOrganizationByIdQuery } from '../../api';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary as MuiAccordionSummary,
  Typography,
  withStyles,
} from '@material-ui/core';
import { useRouteMatch } from 'react-router-dom';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { blue } from '@material-ui/core/colors';
import MainInfo from '../../components/widgets/Organizations/MainInfo';
import LegalInfo from '../../components/widgets/Organizations/LegalInfo';
import OrganizationStructure from '../../components/widgets/Organizations/OrganizationStructure';
import OrganizationTypeSports from '../../components/widgets/Organizations/TypeSports';
import OrganizationDepartmentAffiliation from '../../components/widgets/Organizations/DepartmentAffilation';
import OrganizationAthlete from '../../components/widgets/Organizations/Athletes';

type AccordionTypes =
  | 'MainInfo'
  | 'OrganizationStructure'
  | 'LegalInfo'
  | 'TypeSports'
  | 'ClassifierValues'
  | 'DepartmentAffiliation'
  | undefined;

const AccordionSummary = withStyles({
  root: {
    backgroundColor: blue[700],
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    color: 'white',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

// @TODO: Update View for Dialog request to Archive

const Single: FC<{}> = () => {
  const {
    params: { id },
  } = useRouteMatch();
  // const [page, setPage] = useState<number>(0);
  const [expanded, setExpanded] = useState<AccordionTypes>('MainInfo');

  // const access = usePermission('directory', 'person');
  // const style = useStyle();
  // const canAdd = true;
  const { data } = useOrganizationByIdQuery({ variables: { id } });

  const handleChangeAccordion = (panel: AccordionTypes) => (event: ChangeEvent<{}>, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : undefined);
  };

  return (
    <MainTemplate pageName="" url="">
      <ContentWrapperWidget>
        {id === 'new' ? <h2>Добавить новую организацию</h2> : <h2>Организация: {data?.dirOrganization?.name}</h2>}
        <Accordion expanded={expanded === 'MainInfo'} onChange={handleChangeAccordion('MainInfo')}>
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Общая информация</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <MainInfo id={id} />
          </AccordionDetails>
        </Accordion>
        <Accordion
          disabled={id === 'new'}
          expanded={expanded === 'OrganizationStructure'}
          onChange={handleChangeAccordion('OrganizationStructure')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Структура Организации</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <OrganizationStructure id={id} />
          </AccordionDetails>
        </Accordion>
        <Accordion
          disabled={id === 'new'}
          expanded={expanded === 'LegalInfo'}
          onChange={handleChangeAccordion('LegalInfo')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Юридическая информация</Typography>
          </AccordionSummary>
          <AccordionDetails style={{ flexDirection: 'column' }}>
            <LegalInfo id={id} />
          </AccordionDetails>
        </Accordion>
        <Accordion
          disabled={id === 'new'}
          expanded={expanded === 'TypeSports'}
          onChange={handleChangeAccordion('TypeSports')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Вид спорта</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <OrganizationTypeSports id={id} />
          </AccordionDetails>
        </Accordion>
        <Accordion
          disabled={id === 'new'}
          expanded={expanded === 'DepartmentAffiliation'}
          onChange={handleChangeAccordion('DepartmentAffiliation')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Ведомственная принадлежность</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <OrganizationDepartmentAffiliation id={id} />
          </AccordionDetails>
        </Accordion>
        <Accordion
          disabled={id === 'new'}
          expanded={expanded === 'ClassifierValues'}
          onChange={handleChangeAccordion('ClassifierValues')}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon htmlColor="white" />}>
            <Typography>Спортсмены</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <OrganizationAthlete id={id} />
          </AccordionDetails>
        </Accordion>
      </ContentWrapperWidget>
    </MainTemplate>
  );
};

export default Single;
